import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {ParticleContainer} from "pixi.js";
import {Emitter} from "pixi-particles";
import {TrailUtils} from "./TrailUtils";
import {gsap} from "gsap";
import {HTH} from "../HTH";

export class Trail {
    private _container: ParticleContainer;
    private _head: PIXI.Texture;
    private _layer: StageLayer;
    private _emitter: Emitter;
    private _emitterPos: PIXI.Point;

    constructor() {
        this._layer = HTH.symbolOverlay;
        this._head = HTH.assetLoader.getTextures("flame")[0];
        this.init();
    }

    public play(source: PIXI.Point, dest: PIXI.Point): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();

        this._emitterPos = new PIXI.Point(source.x, source.y);
        this._emitter.updateOwnerPos(this._emitterPos.x, this._emitterPos.y);

        tl.add(() => {
            this._container.visible = true;
        });
        const obj: { x: number, y: number } = {x: source.x, y: source.y};
        tl.add(gsap.to(obj, {
            motionPath:
                {
                    path: TrailUtils.getCurvePathsFromTwoPoints(source, dest, TrailUtils.distanceBetweenTwoPoints(source, dest) * 0.25),
                    type: "cubic",
                    autoRotate: true,
                    useRadians: true,
                    curviness: 3,
                    alignOrigin: [0.5, 0.5],
                },
            onUpdate: () => {
                TrailUtils.updateTrail(5, this._emitterPos, this._emitter, new PIXI.Point(obj.x, obj.y));
            },
            duration: 0.6,
        }));
        tl.add(() => {
            gsap.to(this._container, {
                duration: 0.1, alpha: 0, onComplete: () => {
                    this._emitter.cleanup();
                    this._emitter.destroy();
                    this._container.destroy({children: true});
                    this._layer.removeChild(this._container);
                }
            });
        });
        return tl;
    }


    private init(): void {
        this._container = new ParticleContainer(500, {
            position: true,
            rotation: false,
            uvs: false,
            tint: true
        });
        this._layer.addChild(this._container);
        this._container.visible = false;
        this._emitter = new Emitter(this._container, [this._head], TrailUtils.emitterConfig);
    }

}